<template>
<!--  <el-select-->
<!--    size="mini"-->
<!--    v-model="default_checked_keys"-->
<!--    multiple-->
<!--    filterable-->
<!--    placeholder="选择下级"-->
<!--    :collapse-tags="true" style="width: 400px;">-->
<!--    <el-option-->
<!--      v-for="item in list"-->
<!--      :key="item.house_id"-->
<!--      :label="item.ancestor_name"-->
<!--      :value="item.house_id">-->
<!--    </el-option>-->
<!--  </el-select>-->

  <div style="max-height: 100px;overflow-y: scroll;" :style="{width:width}">
    <div v-if="list.length===0">请选择</div>
    <div v-for="item in list">{{item.ancestor_name}}</div>
  </div>
</template>

<script>
export default {
  name: "SelectProjectTreeComponent",
  props:{
    width:{type:String,default:()=>'400px'},
    project_id: {type:Number|String,default:()=>0},
    checked_keys:{type:String||Number,default:()=>''},
  },
  data(){
    return{
      default_checked_keys:"",
      ids:[],
      options: [],
      loading: false,
      list:[]
    }
  },
  mounted() {
    this.getKeyValue();
    this.reSelect();
  },
  methods:{
    reSelect(){
      if(this.checked_keys){
        let checked_keys=(this.checked_keys+"").split(',').map(id=>id*1);
        if(checked_keys.length){
          this.default_checked_keys=checked_keys
        }
      }
    },
    getKeyValue(){
      const that=this;
      ERP.getRequest({
        url: "admin/Project/getKeyValue",
        data: {ids: that.checked_keys, project_id: that.project_id}
      }, ret => {
        if (ret.code) {
          that.list=ret.data
        }
      });
    }
  },
  watch:{
    checked_keys(n,o){
      this.getKeyValue()
      this.reSelect()
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Admin/EnergyConsumption/components/meter/components/SelectProjectTreeComponent.vue